import PropTypes from 'prop-types';
import { AdvancedCombobox } from '@evertrue/et-components';
import { useInteractionFormContext } from 'apps/interactions/form/context/interaction-form-context';

const InteractionTypeField = ({ onChange, onBlur, name, value, required = true, field, meta, helpers }) => {
  const { interactionTypes = [] } = useInteractionFormContext();

  return (
    <AdvancedCombobox
      label="Select interaction type"
      value={interactionTypes?.find((type) => type?.value === value)}
      options={interactionTypes}
      placeholder="Select type..."
      searchable={true}
      onChange={(selected) => {
        helpers.setValue(selected?.value);
      }}
      onClose={() => {
        helpers.setTouched(true, false);
      }}
    />
  );
};

InteractionTypeField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};

export default InteractionTypeField;
